import React, { FC, useRef } from 'react'
import { Popover, Button, Flex } from '../../../UI'
import { Position } from '@blueprintjs/core'
import cx from 'classnames'
import { ApolloDateInput } from '../../../ApolloDateInput'
import { DateUtil } from '@utils/dateUtil'
import css from './datesFilter.module.scss'

type DatesFilterProps = {
  fromDate: Date | null
  toDate: Date | null
  minDate: Date | null
  maxDate: Date | null
  onClickClear: () => void
  onSelectDay: (fromDate: Date, toDate: Date) => void
}

const DatesFilter: FC<DatesFilterProps> = ({
  minDate,
  maxDate,
  fromDate,
  toDate,
  onClickClear,
  onSelectDay,
}) => {
  const firstClickRef = useRef(false)

  const onDayClick = (date: Date) => {
    if (!firstClickRef.current || !fromDate || !toDate) {
      onSelectDay(date, date)
      firstClickRef.current = true
      return
    }

    if (DateUtil(date).isBefore(fromDate)) {
      onSelectDay(date, toDate)
      firstClickRef.current = false
      return
    }

    onSelectDay(fromDate, date)
    firstClickRef.current = false
  }

  return (
    <Popover
      minimal
      className={css.data_range_filter}
      popoverClassName={css.data_range_filter_popover}
      position={Position.BOTTOM_RIGHT}
      modifiers={{
        offset: {
          options: {
            offset: [0, 8],
          },
        },
      }}
    >
      <Button
        className={css.filter_button}
        iconName="bars-filter"
        onClick={() => {}}
        text="Filter"
      />
      <div>
        <Flex
          align="center"
          justify="space-between"
          className={cx(css.data_range_filter_row, css.data_range_filter_header)}
        >
          <h2 className={css.data_range_filter_title}>Date range</h2>
          <div onClick={onClickClear} className={css.link_button}>
            Clear
          </div>
        </Flex>
        <div className={css.data_range_filter_row}>
          <p className={css.data_range_filter_label}>From</p>
          <ApolloDateInput
            value={fromDate}
            selectedFromDate={fromDate || minDate}
            selectedToDate={toDate || minDate}
            disabledAfter={maxDate}
            disabledBefore={minDate}
            onDayClick={onDayClick}
          />
        </div>
        <div className={css.data_range_filter_row}>
          <p className={css.data_range_filter_label}>To</p>
          <ApolloDateInput
            value={toDate}
            selectedFromDate={fromDate || minDate}
            selectedToDate={toDate || minDate}
            disabledAfter={maxDate}
            disabledBefore={minDate}
            onDayClick={onDayClick}
          />
        </div>
      </div>
    </Popover>
  )
}

export default DatesFilter
